export enum ButtonColorType {
  Warning = 'warning',
  Danger = 'danger',
  Success = 'success',
  Info = 'info',
  Default = ''
}
